<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs" >{{ $t('position.nameKh') }}</label>
        <input
          v-model="model.position_name_kh"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('position_name_kh') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('position_name_kh')"
        >{{ errors.first('position_name_kh') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('position.nameEn') }}</label>
        <input
          v-model="model.position_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('position_name_en') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('position_name_en')"
        >{{ errors.first('position_name_en') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
          $t('cancel')
          }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
        >{{ $t('save') }}</ts-button>
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
        >{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'companyForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        position_id: 0,
        position_name_kh: null,
        position_name_en: null
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('employee/position', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('employee/position/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('employee/position/update', {
          id: this.model.position_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.position_id = this.edit_data.position_id
        this.model.position_name_kh = this.edit_data.position_name_kh
        this.model.position_name_en = this.edit_data.position_name_en
      }
    }
  }
}
</script>
